import React from 'react';

import ArrowIcon from '@mui/icons-material/ArrowForward';
import { Box, Typography } from '@mui/material';
import { capitalize } from 'lodash';
import SignUpOnboardingStep from './SignUpOnboardingStep';
import { careUserType } from '../../constants';
import useStore from '../../Store/Store';
import Logo from '../../images/logo.png';
import Button from '../../components/Button';

const UserType = ({ userType, setUserType, handleNextStep, errorMessage, loader }) => {
  const width = useStore((state) => state.screenWidth);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: width > 1050 ? '100%' : '100%',
        padding: '1rem',
      }}
    >
      <Box
        component="img"
        sx={{ width: '55px', height: '37.56px', marginBottom: '2rem' }}
        alt="Mask group"
        src={Logo}
      />
      <div style={{ paddingInline: '4rem', paddingBlock: '5rem' }}>
        <SignUpOnboardingStep step={1} />

        <Typography variant="h4" gutterBottom mb={6}>
          Who are you?
        </Typography>

        {Object.values(careUserType).map((item) => (
          <Box
            display={'flex'}
            alignItems="center"
            justifyContent="space-between"
            px={3}
            py={1}
            bgcolor={userType === item ? 'rgba(230,242,240,1)' : '#f5f5f7'}
            borderRadius={'20px'}
            height="82px"
            border={userType === item ? '1px solid rgba(0,121,107,1)' : 'none'}
            style={{ cursor: 'pointer' }}
            marginBottom="20px"
            onClick={() => setUserType(item)}
          >
            <Typography variant="h2" color={'rgba(29,29,31,1)'} fontWeight={500} fontSize="20px" lineHeight={'28px'}>
              I am {capitalize(item.replace('_', ' '))}
            </Typography>
            <ArrowIcon />
          </Box>
        ))}

        <Button fullWidth onClick={handleNextStep} loading={loader} text="Next" />
      </div>
      <Typography variant="subtitle1" style={{ color: 'red', marginTop: '-30px' }} textAlign="center">
        {errorMessage}
      </Typography>
    </Box>
  );
};

export default UserType;
